export default __webpack_public_path__ + "static/media/cm12y.c9103a6b.jpg";